module.exports = __webpack_public_path__ + "static/media/water.cf6592ff.svg";